import Vue from "vue";
import VueRouter from "vue-router";
import firebase from "firebase";
import Landing from "../views/Landing.vue";
import NewInvoice from "../views/NewInvoice.vue";
import NewClient from "../views/NewClient.vue";
import NewProject from "../views/NewProject.vue";
import Login from "../views/Login.vue";
import SignUp from "../views/SignUp.vue";
import Dashboard from "../views/Dashboard.vue";
import Invoice from "../views/Invoice.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Landing",
    component: Landing,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/signup",
    name: "SignUp",
    component: SignUp,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/newinvoice",
    name: "NewInvoice",
    component: NewInvoice,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/newclient",
    name: "NewClient",
    component: NewClient,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/newproject",
    name: "NewProject",
    component: NewProject,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/:id",
    name: "Invoice",
    component: Invoice,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next("login");
  else if (!requiresAuth && currentUser) next("dashboard");
  else next();
});

export default router;
